import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/metrics/recording`

export const getLive = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/live`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Clips created in the server's trailing window (window_seconds in the
// response), oldest first. Stateless rolling window: callers dedupe by
// source_id across polls.
export const getRecentClips = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/clips`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// start/end are epoch seconds; end omitted means "now" (the server
// defaults it) and the server picks the resolution for the window.
export const getHistory = async ({ start, end }) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/history`, {
      params: end != null ? { start, end } : { start },
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Ad-hoc PromQL (staff-only passthrough). Query alone = instant query
// evaluated at "now"; returns the raw Prometheus response JSON.
export const promql = async (query) => {
  try {
    const { data } = await axios.post(`${ADMIN_API_URL}/metrics/promql`, {
      query,
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
